import { render, staticRenderFns } from "./Signable.vue?vue&type=template&id=ebdbfb22&scoped=true"
import script from "./Signable.vue?vue&type=script&lang=ts"
export * from "./Signable.vue?vue&type=script&lang=ts"
import style0 from "./Signable.vue?vue&type=style&index=0&id=ebdbfb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdbfb22",
  null
  
)

export default component.exports